import { IconSVG } from '../types';

export const Pause = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15 19q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 15 5h2q.824 0 1.413.588Q19 6.175 19 7v10q0 .824-.587 1.413A1.93 1.93 0 0 1 17 19zm-8 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 7 5h2q.825 0 1.412.588Q11 6.175 11 7v10q0 .824-.588 1.413A1.93 1.93 0 0 1 9 19zm8-2h2V7h-2zm-8 0h2V7H7z"
       />
    </svg>
  );
};
